import React from 'react';
import './Header.css';

const Header = ({ leftAction, rightAction }) => {
    return (
        <header className="app-header">
            <div className="header-content">
                <div className="header-left">
                    {leftAction}
                </div>
                <div className="header-center">
                    <div className="logo-section">
                        <img src="/logo.png" alt="Ithal by MR Logo" className="logo-image" />
                    </div>
                </div>
                <div className="header-right">
                    {rightAction}
                </div>
            </div>
        </header>
    );
};

export default Header;
